import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[appUrlValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: UrlValidatorDirective,
      multi: true
    }
  ],
  standalone:true
})
export class UrlValidatorDirective implements Validator {
//   private urlPattern = /^(https?:\/\/)?[^\s]+$/;
  private urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w.-]*)*\/?$/;

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value || this.urlPattern.test(value)) {
      return null; // Valid URL or empty (optional)
    }
    return { invalidUrl: true }; // Invalid URL
  }
}
